import { useEffect, useMemo, useRef, useState } from 'react';
import { ChangeAlertCallbackType } from '../../../Root';
import { IconButton, Switch, Tooltip } from '@mui/material';
import { FraudService } from '../../../../services/FraudService';
import { catalogFraudChannel, catalogFraudOperation, fraudTypeList } from '../../../../util/DataObject';
import { useConfirm } from '../../../modals/confirm';
import { Edit } from '@mui/icons-material';
import moment from 'moment';
moment.locale('es');

export const useFraudTable = (changeAlert: ChangeAlertCallbackType, onOpenUpdateState, redirectUpdateDialog) => {
    const [data, setData] = useState([]);
    const [dataConfig, setDataConfig] = useState([]);
    const [uuid, setUuid] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({channel: '', operation: 'moneyout'});
    const fraudService = useRef<FraudService>();

    const [tabActive, setTabActive] = useState('blacklist');
    const [tabs] = useState(fraudTypeList);

    const { DialogConfirm, confirm: confirmUpdateStatus } = useConfirm(
        'Cambiar estatus',
        '¿Estás seguro que deseas realizar este cambio?'
    )

    const saveData = async (result) => {
        let validate = Array.isArray(result?.content)
        setData(JSON.parse(JSON.stringify(validate ? result.content || [] : [result.content])));
        setTotalRows(result?.pagination?.total_documents || 0);
    };

    const getData = async (newPage, newPerPage=perPage, filters=null, tab=tabActive) => {        
        setLoading(true);

        let data = {
            channel: filters.channel,
            operation: filters.operation,
            type: tab,
            count: newPerPage
        }
        if(search){
            data['entity_uuid'] = search
        }
        
        const response = await fraudService.current.fraudList(data);
        if(response['data']?.response === 'OK'){
            setLoading(false);
            saveData(response.data.widget[0].data || {content: []})
        } else {
            setLoading(false);
            saveData({content: []})
            changeAlert(true, 'error', response['data'].message || 'Error al consultar servicio');
        }

        setPage(newPage)
    };

    const getDataAcc = async (newPage, newPerPage=perPage, filters=null, tab=tabActive, config=false) => {        
        setLoading(true);
        let data = {}

        if(search){
            data['filters'] = {}
            data['filters']['entity_uuid'] = search
            if(filters['operation']){
                data['filters']['operation'] = filters['operation']
            }
            if(filters['channel']){
                data['filters']['channel'] = filters['channel']
            }
        } else {
            data['count'] = newPerPage
            data['filters'] = []
            if(filters['operation']){
                data['filters'].push({name: 'operation', value: filters['operation']})
            }
            if(filters['channel']){
                data['filters'].push({name: 'channel', value: filters['channel']})
            }
        }

        let typeService = ''
        let num = 0
        
        const getService = () => {
            switch (tab + '|' + (search !== '')) {
                case 'accumulator|true':
                    typeService = 'fraudAccumulatorFind'
                    num = 1
                    break
                case 'accumulator|false':
                    typeService = 'fraudAccumulatorGet'
                    num = 2
                    break
                case 'configAcc|true':
                    typeService = 'fraudAccConfigFind'
                    num = 3
                    break
                case 'configAcc|false':
                    typeService = 'fraudAccConfigGet'
                    num = 4
                    break
                case 'reboot|false':
                    typeService = 'fraudRebootGet'
                    num = 5
                    break
                case 'reboot|true':
                    typeService = 'fraudRebootFind'
                    num = 6
                    break
                default:
                    break
            }
        }
        getService()

        if(typeService){
            const response = await fraudService.current[typeService](data);
            if(response['data']?.response === 'OK'){
                setLoading(false);

                switch (num) {
                    case 1:
                    case 2:
                        saveData(response.data.widget[0].data || {content: []})
                        await getDataAcc(1, perPage, filters, 'configAcc')
                        break;
                    case 3:
                    case 4:
                        !config && setDataConfig(response.data.widget[0].data.content || []);
                        config && saveData(response.data.widget[0].data || {content: []}) && setDataConfig([])
                        break;
                    case 5:
                    case 6:
                        if(response.data.widget[0].data.content){
                            saveData(response.data.widget[0].data)
                        } else {
                            saveData({content: []})
                        }
                        break;
                    default:
                        break;
                }
            } else {
                setLoading(false);
                saveData({content: []})
                setDataConfig([])
                changeAlert(true, 'error', response['data'].message || 'Error al consultar servicio');
            }
    
            setPage(newPage)
        }

    };

    const handlePageChange = (newPage) => {
        setPage(newPage)
        getData(newPage, perPage, filters ? filters : null)
    };
    const handlePerRowsChange = async (newPerPage, newPage) => {
        setPage(newPage)
        setPerPage(newPerPage);
        getData(newPage, newPerPage);
    };

    const changeValueSearch = (type, e) => {
        let f = filters
        f[type] = e.target.value.trimStart();
        if(type === 'uuid'){
            setSearch(e.target.value.trimStart())
        }
        setFilters(JSON.parse(JSON.stringify(f)));
    };

    const changeTab = async (tab: string) => {
        setLoading(true);        
        setTabActive(tab);
        selectService(tab)
    };

    const selectService = (tab: string) => {
        switch (tab) {
            case 'blacklist':
            case 'whitelist':
                getData(1, perPage, filters, tab)
                break;
            case 'accumulator':
            case 'configAcc':
            case 'reboot':
                getDataAcc(1, perPage, filters, tab, true)
                break;
            default:
                break;
        }
    }

    const fraudFilter = () => {        
        const chaeck = (element) => element !== '';
        
        if(Object.values(filters).filter(chaeck).length > 0){
            selectService(tabActive)
        } else {
            changeAlert(true, 'error', 'Debes incluir al menos un filtro en tu búsqueda');
        }
    }
    const reset = () => {
        setSearch('')
        setFilters({channel: 'domestic', operation: 'moneyout'})
        setPage(1)
        getData(1, perPage)
    }

    const getExpiration = (row) => {
        const getDays = moment.duration(moment(row.expired_date).diff(moment(new Date())))
        
        if(getDays.asDays() < 0){
            return 'Expirado'
        } else {
            return `${getDays.hours()}h ${getDays.minutes()}m ${getDays.seconds()}s`
        }
    }

    const disabled = async (data) => {
        const isConfirm = await confirmUpdateStatus()
        if (isConfirm) {
            setLoading(true);

            let request = {
                filters: {
                    entity_uuid: data.entity_uuid,
                    operation: data.operation,
                    channel: data.channel
                },
                updates: {
                    active: false,
                    enabled: false,
                    expired_date: new Date(new Date().setHours(0,0,0,0)).toJSON()
                },
                type: tabActive
            }
            
            const response = await fraudService.current.fraudUpdate(request);
            if(response.data?.response === 'OK'){
                setLoading(false);
                getData(1, perPage, filters, tabActive)
                changeAlert(true, 'success', 'El estatus se actualizó con éxito');
            } else {
                setLoading(false);
                changeAlert(true, 'error', response.data.message || 'Error al actualizar estatus');
            }
        }
    };

    const disabledAcc = async (data) => {
        const isConfirm = await confirmUpdateStatus()
        if (isConfirm) {
            setLoading(true);
            let request = {
                filters: {
                    entity_uuid: data.entity_uuid,
                    operation: data.operation,
                    channel: data.channel
                },
                accumulator: {
                    accumulators: data['accumulators'],
                    fields_expired: data['fields_expired'],
                    active: data['active'] ? false : true,
                    enabled: data['enabled'] ? false : true 
                }
            }
            
            const response = await fraudService.current.fraudAccumulatorUpdate(request);
            if(response.data?.response === 'OK'){
                setLoading(false);
                selectService(tabActive)
                changeAlert(true, 'success', 'El estatus se actualizó con éxito');
            } else {
                setLoading(false);
                changeAlert(true, 'error', response.data.message || 'Error al actualizar estatus');
            }
        }
    };

    const changeStatusConfig = async (data) => {
        const isConfirm = await confirmUpdateStatus()
        if (isConfirm) {
            setLoading(true);
            let request = {
                filters: {
                    operation: data.operation,
                    channel: data.channel
                },
                accumulator: {
                    accumulators: data['accumulators'],
                    field_expired: data['field_expired'],
                    reboots: data['reboots'],
                    active: data['active'] ? false : true
                }
            }
            
            const response = await fraudService.current.fraudAccConfigUpdate(request);
            if(response.data?.response === 'OK'){
                setLoading(false);
                selectService(tabActive)
                changeAlert(true, 'success', 'El estatus se actualizó con éxito');
            } else {
                setLoading(false);
                changeAlert(true, 'error', response.data.message || 'Error al actualizar estatus');
            }
        }
    };

    const updateReboot = async (data) => {
        const isConfirm = await confirmUpdateStatus()
        if (isConfirm) {
            setLoading(true);

            let request = {
                filters: {
                    uuid: data.uuid
                },
                reboot: {
                    channel: data.channel,
                    operation: data.operation,
                    entity_uuid: data.entity_uuid,
                    name: data.name,
                    expired_date: data.expired_date,
                    active: false
                }
            }
            
            const response = await fraudService.current.fraudRebootUpdate(request);
            if(response.data?.response === 'OK'){
                let f = {channel: '', operation: 'moneyout'}
                setFilters(JSON.parse(JSON.stringify(f)));
                setLoading(false);

                getDataAcc(1, perPage, f, tabActive)
                changeAlert(true, 'success', 'El estatus se actualizó con éxito');
            } else {
                setLoading(false);
                changeAlert(true, 'error', response.data.message || 'Error al actualizar estatus');
            }
        }
    };
 
    useEffect(() => {
        setSearch('')
        setUuid([])
        fraudService.current = new FraudService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const calculateColumns = useMemo(() => {
        const columns = []
        const pushEntity = () => {
            columns.push(
                { selector: (row) => row.entity_uuid, name: 'Customer UUID', wrap: true, width: '30%', sortable: false },
            )
        }
        const pushUdate = (type, name) => {
            columns.push(
                { selector: (row) => moment(row[type]).format('L'), name: `Fecha ${name}`, wrap: true, width: '17%', sortable: false },
            )
        }
        const pushOpChannel = () => {
            columns.push(
                { selector: (row) => row.channel, name: 'Canal', wrap: true, width: '13%' },
                { selector: (row) => row.operation, name: 'Operación', wrap: true, width: '13%' },
            )
        }
        const pushStatus = (active, inactive) => {
            columns.push(
                { cell: (row) => {
                        return <Switch checked={row.active} onChange={row.active ? inactive.bind(this, row) : active.bind(this, row)} color='secondary'/>
                    }, name: 'Estatus', width:'10%', wrap: true, sortable: true, center: true
                }
            )
        }
        const pushEdit = (name, origin=null) => {
            columns.push(
                { cell: (row) => {
                        return (
                            <Tooltip title='Editar'>
                                <IconButton onClick={redirectUpdateDialog.bind(this, name, row, origin)}>
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                        )
                    }, name: 'Editar', width:'10%', wrap: true, sortable: true, center: true
                }
            )
        }

        switch (tabActive) {
            case 'blacklist':
                pushEntity()
                pushUdate('expired_date', 'expiración')
                columns.push(
                    { selector: (row) => getExpiration(row), name: 'Tiempo restante', wrap: true, width: '15%', sortable: false },
                )
                pushOpChannel()
                pushStatus(onOpenUpdateState, disabled)
                break;

            case 'whitelist':
                pushEntity()
                pushUdate('cdate', 'creación')
                pushUdate('udate', 'actualización')
                pushOpChannel()
                pushStatus(onOpenUpdateState, disabled)
                break;

            case 'accumulator':
                pushEntity()
                pushOpChannel()
                pushUdate('udate', 'actualización')
                pushStatus(disabledAcc, disabledAcc)
                pushEdit('configAcc', 'accumulator')                
                break;
        
            case 'configAcc':
                columns.push(
                    { selector: (row) => row.key, name: 'Key', wrap: true, width: '30%', sortable: false },
                )
                pushOpChannel()
                pushUdate('udate', 'actualización')
                pushStatus(changeStatusConfig, changeStatusConfig)
                pushEdit('configAcc')                
                break;
            case 'reboot':
                pushEntity()
                pushUdate('cdate', 'creación')
                pushUdate('udate', 'actualización')
                pushOpChannel()
                pushStatus(updateReboot, updateReboot)
                break;
            default:
                break;
        }

        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid, tabActive])

    return { columns: calculateColumns, data, dataConfig, loading, filters, page, perPage, totalRows, channel: catalogFraudChannel, operation: catalogFraudOperation, tabs, tabActive, fraudTypeList, changeTab, reset, fraudFilter, changeValueSearch, saveData, getData, selectService, handlePageChange, handlePerRowsChange, DialogConfirm}

}
